import { createAction, props } from '@ngrx/store';
import { Chat, ChatMessage, ChatThreads } from '@qvs/core';
import { UserPresenceResponse } from '@chat-api';

export const setChatLoadingStatus = createAction(
  '[Chat] Set loading status',
  props<{ isLoading: boolean; hasErrors: boolean }>()
);

export const loadChat = createAction('[Chat] Load Chat', props<{ authorId: string; intendedUserIds: string[] }>());

export const loadChatPage = createAction('[Chat] Load More Chat Pages', props<{ page: number }>());

export const loadChatSuccess = createAction('[Chat] Load Chat Success', props<{ chat: Chat }>());

export const loadChatFailure = createAction(
  '[Chat] Load Chat Failure',
  props<{
    intendedUserIds: string[];
    authorId: string;
  }>()
);

export const updateOutOfOfficeMessage = createAction(
  '[Chat] Update Display Message Out of Office',
  props<{ message: string; enabled: boolean }>()
);

export const updateOutOfOfficeMessageSuccess = createAction(
  '[Chat] Update Display Message Out of Office Success',
  props<{ message: string; enabled: boolean }>()
);

export const updateOutOfOfficeMessageFailure = createAction(
  '[Chat] Update Display Message Out of Office Failure',
  props<{ error: any }>()
);

export const loadOutOfOfficeMessage = createAction('[Chat] Load Message Out of Office', props<{ chatAuthorId: string }>());

export const loadOutOfOfficeMessageSuccess = createAction(
  '[Chat] Load Message Out of Office Success',
  props<{ message: string; enabled: boolean }>()
);

export const loadOutOfOfficeMessageFailure = createAction('[Chat] Load Message Out of Office Failure', props<{ error: any }>());

export const sendChatTextMessage = createAction('[Chat] Send Text Message', props<{ text: string; intendedUserIds: string[] }>());

export const sendChatAttachmentMessage = createAction(
  '[Chat] Send Picture Message',
  props<{ attachment: string; mimeType: string; fileName: string; intendedUserIds: string[] }>()
);

export const sendChatMessageFailure = createAction('[Chat] Send Message Failure', props<{ error: any }>());

export const sendChatMessageFailSizeFailure = createAction('[Chat] Send Message Filesize Failure', props<{ error: any }>());

export const loadChatMessageImage = createAction('[Chat] Load Chat Message Image', props<{ message: ChatMessage }>());

export const loadChatMessagePdf = createAction('[Chat] Load Chat Message PDF', props<{ message: ChatMessage }>());

export const loadChatMessageImageSuccess = createAction(
  '[Chat] Load Chat Message Image Success',
  props<{ message: ChatMessage; base64: string; url: string }>()
);

export const loadChatMessageImageFailure = createAction(
  '[Chat] Load Chat Message Image Failure ',
  props<{ message: ChatMessage }>()
);

export const loadChatMessagePdfSuccess = createAction(
  '[Chat] Load Chat Message PDF Success',
  props<{ message: ChatMessage; base64: string; url: string }>()
);

export const loadChatMessagePdfFailure = createAction('[Chat] Load Chat Message PDF Failure ', props<{ message: ChatMessage }>());

export const sendOrReceiveChatMessageSuccess = createAction(
  '[Chat] Send or Receive Message Success',
  props<{ message: ChatMessage }>()
);

export const addChatMessageToNotRead = createAction('[Chat] Add message to not read', props<{ message: ChatMessage }>());

export const removeAllChatMessagesFromNotRead = createAction(
  '[Chat] Remove all chat messages from not read',
  props<{ authorId: string }>()
);

export const loadUserPresenceStatus = createAction('[Chat] Load User Presence Status');

export const loadUserPresenceStatusSuccess = createAction(
  '[Chat] Load User Presence Status Success',
  props<{ status: UserPresenceResponse.StatusEnum; desc: string }>()
);

export const loadUserPresenceStatusFailure = createAction('[Chat] Load User Presence Status Failure');

export const loadChatMessagesReceived = createAction('[Chat] Load Chat Messages Received');

export const loadChatMessagesReceivedSuccess = createAction(
  '[Chat] Load Chat Messages Received Success',
  props<{ messages: ChatMessage[] }>()
);

export const loadChatMessagesReceivedFailure = createAction('[Chat] Load Chat Messages Received Failure');

export const loadChatThreads = createAction('[Chat] Load Chat Threads');

export const loadChatThreadsSuccess = createAction('[Chat] Load Chat Threads Success', props<{ threads: ChatThreads }>());

export const loadChatThreadsFailure = createAction('[Chat] Load Chat Threads Failure');

export const updateAllMessagesReadStatus = createAction(
  '[Chat] Update All Chat Messages Read Status',
  props<{ authorId: string }>()
);

export const updateAllMessagesReadStatusSuccess = createAction('[Chat] Update All Chat Messages Read Status Success');

export const updateAllMessagesReadStatusFailure = createAction('[Chat] Update All Chat Messages Read Status Failure');
